export default "__VITE_ASSET__T8Cuo223__"